import React, { useRef, useState } from 'react';
import { FaMinus, FaPlus } from 'react-icons/fa';
import { AccordionContainer, AccordionList } from './newAccordion.styled';

const PostAccordion = ({ accordionData, accordionTitle, isOpen = false }) => {
  const [openIndex, setOpenIndex] = useState(isOpen ? 0 : null);
  const accordionRefs = useRef([]);

  const toggleAccordion = (index) => {
    // Check if you're opening a new accordion, and scroll to it
    if (openIndex !== index && accordionRefs.current[index]) {
      setOpenIndex(index); // Set open index first to expand the content

      // Delay scrollIntoView slightly to allow content to expand first
      setTimeout(() => {
        accordionRefs.current[index].scrollIntoView({
          behavior: 'smooth',
          block: 'nearest', // Prevents it from scrolling too far up
        });
      }, 300); // Delay to match the content transition speed
    } else {
      // Close the currently open accordion
      setOpenIndex(null);
    }
  };

  return (
    <AccordionContainer>
      {accordionTitle && <h3>{accordionTitle}</h3>}
      <AccordionList>
        {Array.isArray(accordionData) &&
          accordionData.length &&
          accordionData.map((item, index) => (
            <div key={index} className='accordion-container'>
              <div
                className='accordion-header'
                onClick={() => toggleAccordion(index)}
                ref={(el) => (accordionRefs.current[index] = el)} // Assign ref to each header
              >
                <h2>{item.title}</h2>
                <span className='accordion-icon'>
                  {openIndex === index ? <FaMinus /> : <FaPlus />}
                </span>
              </div>
              <div
                className={`accordion-content ${
                  openIndex === index ? 'open' : ''
                }`}
                style={{ maxHeight: openIndex === index ? '500px' : '0' }}
              >
                <div
                  className='content'
                  dangerouslySetInnerHTML={{ __html: item.description }}
                />
              </div>
            </div>
          ))}
      </AccordionList>
    </AccordionContainer>
  );
};

export default PostAccordion;
